<template>
  <div class="col-span-12 lg:col-span-6">
    <div class="intro-y box filter-cod">
      <div id="basic-accordion" class="p-5">
        <div id="faq-accordion-1" class="accordion">
          <div v-if="filters.max_delivery" class="accordion-item">
            <div id="faq-accordion-content-1" class="accordion-header">
              <button
                class="flex flex-row justify-between accordion-button font-poppins font-bold text-base text-theme-1"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#faq-accordion-collapse-1"
                aria-expanded="true"
                aria-controls="faq-accordion-collapse-1"
                style="
                  font-family: 'Poppins';
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  line-height: 24px;
                  color: black;
                "
              >
                <p class="text-[#E85C04]">Tiempos de entrega</p>
                <ChevronDownIcon />
              </button>
            </div>
            <div
              id="faq-accordion-collapse-1"
              class="accordion-collapse collapse show"
              aria-labelledby="faq-accordion-content-1"
              data-bs-parent="#faq-accordion-1"
            >
              <div class="accordion-body text-gray-700 leading-relaxed">
                <Slider
                  v-if="timeFilterModel != undefined"
                  v-model="timeFilterModel"
                  :format="rangeTime.format"
                  :min="rangeTime.min"
                  :max="rangeTime.max"
                  :tooltip-position="rangeTime.tooltipPosition"
                  :step="1"
                  class="slider-custom my-8"
                />
              </div>
            </div>
          </div>
          <div v-if="filters.product_versions" class="accordion-item">
            <div id="faq-accordion-content-2" class="accordion-header">
              <button
                class="flex flex-row justify-between accordion-button font-poppins font-bold text-base text-theme-1"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#faq-accordion-collapse-2"
                aria-expanded="false"
                aria-controls="faq-accordion-collapse-2"
                style="
                  font-family: 'Poppins';
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  line-height: 24px;
                  color: black;
                "
              >
                <p class="text-[#E85C04]">Tipo de producto</p>
                <ChevronDownIcon />
              </button>
            </div>
            <div
              id="faq-accordion-collapse-2"
              class="accordion-collapse collapse"
              aria-labelledby="faq-accordion-content-2"
              data-bs-parent="#faq-accordion-1"
            >
              <div class="accordion-body text-gray-700 leading-relaxed">
                <div>
                  <div class="form-check mt-2">
                    <input
                      :id="`selectAllProductVersion0${type}`"
                      class="form-check-input"
                      type="checkbox"
                      :checked="productVersionsSelectModel.length === filters.product_versions?.length"
                      v-model="selectAllProductVersion"
                    />
                    <label
                      class="form-check-label font-poppins text-base text-theme-1"
                      :for="`selectAllProductVersion0${type}`"
                    >
                      Todos los tipo de producto
                    </label>
                  </div>
                  <div
                    class="form-check mt-2"
                    v-for="version in filters.product_versions || []"
                    :key="version.id"
                  >
                    <input
                      :id="`versions-checkbox-switch-${version.id}${type}`"
                      class="form-check-input"
                      type="checkbox"
                      :checked="productVersionsSelectModel.includes(version.id)"
                      @change="
                        productVersionsSelectModel = $event.target.checked
                          ? [...productVersionsSelectModel, version.id]
                          : productVersionsSelectModel.filter(
                              (item) => item !== version.id
                            )"
                    />
                    <label
                      class="form-check-label font-poppins text-base text-theme-1 flex-1"
                      :for="`versions-checkbox-switch-${version.id}${type}`"
                    >
                      {{ version.name }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="filters.colors" class="accordion-item">
            <div id="faq-accordion-content-3" class="accordion-header">
              <button
                class="flex flex-row justify-between accordion-button collapsed font-poppins font-bold text-base text-theme-1"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#faq-accordion-collapse-3"
                aria-expanded="false"
                aria-controls="faq-accordion-collapse-3"
                style="
                  font-family: 'Poppins';
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  line-height: 24px;
                  color: black;
                "
              >
                <p class="text-[#E85C04]">Color</p>
                <ChevronDownIcon />
              </button>
            </div>
            <div
              id="faq-accordion-collapse-3"
              class="accordion-collapse collapse"
              aria-labelledby="faq-accordion-content-3"
              data-bs-parent="#faq-accordion-1"
            >
              <div class="accordion-body text-gray-700 leading-relaxed">
                <div class="grid grid-cols-4 gap-4">
                  <div v-for="color in filters.colors || []" :key="color">
                    <a
                      href="javascript:;"
                      class="color-picker"
                      :style="{ background: color }"
                      :class="{
                        'color-picker-active': colorFilterModel === color
                      }"
                      @click="
                        colorFilterModel =
                          color !== colorFilterModel ? color : undefined
                      "
                    ></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="filters.categories" class="accordion-item">
            <div id="faq-accordion-content-4" class="accordion-header">
              <button
                class="flex flex-row justify-between accordion-button font-poppins font-bold text-base text-theme-1"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#faq-accordion-collapse-4"
                aria-expanded="false"
                aria-controls="faq-accordion-collapse-4"
                style="
                  font-family: 'Poppins';
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  line-height: 24px;
                  color: black;
                "
              >
                <p class="text-[#E85C04]">Categoría</p>
                <ChevronDownIcon />
              </button>
            </div>
            <div
              id="faq-accordion-collapse-4"
              class="accordion-collapse collapse"
              aria-labelledby="faq-accordion-content-4"
              data-bs-parent="#faq-accordion-1"
            >
              <div class="accordion-body text-gray-700 leading-relaxed">
                <div>
                  <div class="form-check mt-2">
                    <input
                      :id="`selectAllCategories0${type}`"
                      class="form-check-input"
                      type="checkbox"
                      :checked="productTypesFilterModel.length === filters.categories?.length"
                      v-model="selectAllCategories"
                    />
                    <label
                      class="form-check-label font-poppins text-base text-theme-1"
                      :for="`selectAllCategories0${type}`"
                    >
                      Todas las categorías
                    </label>
                  </div>
                  <div
                    class="form-check mt-2"
                    v-for="productType in filters.categories || []"
                    :key="productType.id"
                  >
                    <input
                      :id="`productType-checkbox-switch-${productType.id}${type}`"
                      class="form-check-input"
                      type="checkbox"
                      :checked="productTypesFilterModel.includes(productType.id)"
                      @change="
                        productTypesFilterModel = $event.target.checked
                          ? [...productTypesFilterModel, productType.id]
                          : productTypesFilterModel.filter(
                              (item) => item !== productType.id
                            )"
                    />
                    <label
                      class="form-check-label font-poppins text-base text-theme-1 flex-1"
                      :for="`productType-checkbox-switch-${productType.id}${type}`"
                    >
                      {{ productType.name }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="filters.product_types" class="accordion-item">
            <div id="faq-accordion-content-5" class="accordion-header">
              <button
                class="flex flex-row justify-between accordion-button font-poppins font-bold text-base text-theme-1"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#faq-accordion-collapse-5"
                aria-expanded="false"
                aria-controls="faq-accordion-collapse-5"
                style="
                  font-family: 'Poppins';
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  line-height: 24px;
                  color: black;
                "
              >
                <p class="text-[#E85C04]">Temporalidad</p>
                <ChevronDownIcon />
              </button>
            </div>
            <div
              id="faq-accordion-collapse-5"
              class="accordion-collapse collapse"
              aria-labelledby="faq-accordion-content-5"
              data-bs-parent="#faq-accordion-1"
            >
              <div class="accordion-body text-gray-700 leading-relaxed">
                <div>
                  <div class="form-check mt-2">
                    <input
                      :id="`selectAllProductTypes0${type}`"
                      class="form-check-input"
                      type="checkbox"
                      :checked="categoriesFilterModel.length === filters.product_types?.length"
                      v-model="selectAllProductTypes"
                    />
                    <label
                      class="form-check-label font-poppins text-base text-theme-1"
                      :for="`selectAllProductTypes0${type}`"
                    >
                      Todas las temporalidades
                    </label>
                  </div>
                  <div
                    class="form-check mt-2"
                    v-for="category in filters.product_types || []"
                    :key="category.id"
                  >
                    <input
                      :id="`category-checkbox-switch-${category.id}${type}`"
                      class="form-check-input"
                      type="checkbox"
                      :checked="categoriesFilterModel.includes(category.id)"
                      @change="
                        categoriesFilterModel = $event.target.checked
                          ? [...categoriesFilterModel, category.id]
                          : categoriesFilterModel.filter(
                              (item) => item !== category.id
                            )"
                    />
                    <label
                      class="form-check-label font-poppins text-base text-theme-1 flex-1"
                      :for="`category-checkbox-switch-${category.id}${type}`"
                    >
                      {{ category.name }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="filters.max_price" class="accordion-item">
            <div id="faq-accordion-content-7" class="accordion-header">
              <button
                class="flex flex-row justify-between accordion-button collapsed font-poppins font-bold text-base text-theme-1"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#faq-accordion-collapse-7"
                aria-expanded="false"
                aria-controls="faq-accordion-collapse-7"
                style="
                  font-family: 'Poppins';
                  font-style: normal;
                  font-weight: 400;
                  font-size: 16px;
                  line-height: 24px;
                  color: black;
                "
              >
                <p class="text-[#E85C04]">Precio</p>
                <ChevronDownIcon />
              </button>
            </div>
            <div
              id="faq-accordion-collapse-7"
              class="accordion-collapse collapse"
              aria-labelledby="faq-accordion-content-7"
              data-bs-parent="#faq-accordion-1"
            >
              <div class="accordion-body text-gray-700 leading-relaxed">
                <Slider
                  v-if="priceFilterModel != undefined && priceFilterModel?.length > 0"
                  v-model="priceFilterModel"
                  :format="rangePrice.format"
                  :step="1"
                  :min="rangePrice.min"
                  :max="rangePrice.max"
                  :tooltip-position="rangePrice.tooltipPosition"
                  class="slider-custom"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Slider from '@vueform/slider'
import { formatter } from '@/utils/tools'

export default {
  components: {
    Slider
  },
  props: {
    type: {
      require: false,
      type: String,
      default: 'web'
    },
    filters: {
      type: Object,
      default: () => ({})
    }
  },
  emits: [
    'update:isMobile'
  ],
  data() {
    return {
      dataLoaded: false,
      rangeTime: {
        min: 1,
        max: undefined,
        rangeValue: undefined,
        tooltipPosition: 'bottom',
        format: (value) => `${Math.round(value)} día${Math.round(value) !== 1 ? 's' : ''}`
      },
      rangePrice: {
        min: 0,
        max: undefined,
        rangeValue: undefined,
        tooltipPosition: 'bottom',
        format: (value) => `${formatter.format(value)} MXN`
      },
      selectAllProductVersion: false,
      selectAllCategories: false,
      selectAllProductTypes: false
    }
  },
  beforeMount() {
    this.rangeTime.max = Number(this.filters.max_delivery || 100)
    this.rangePrice.max = Number(this.filters.max_price || 100)
    this.dataLoaded = true

    if (this.timeFilterModel === undefined) {
      this.timeFilterModel = Number(this.filters.max_delivery || 100)
    }

    if (this.priceFilterModel === undefined) {
      this.priceFilterModel = [0, this.rangePrice.max]
    }
  },
  computed: {
    storeFilters: {
      get() {
        return this.$store.state.catalogue.filters
      },
      set(value) {
        this.$store.commit('catalogue/setFilters', value)
      }
    },
    timeFilterModel: {
      get: function () {
        return this.storeFilters.time
      },
      set: function (val) {
        this.storeFilters = { ...this.storeFilters, time: val }
        this.$emit('update:isMobile', this.type === 'mobile')
      }
    },
    productVersionsSelectModel: {
      get: function () {
        return this.storeFilters.productVersions
      },
      set: function (val) {
        this.storeFilters = { ...this.storeFilters, productVersions: val }
        this.$emit('update:isMobile', this.type === 'mobile')
      }
    },
    colorFilterModel: {
      get: function () {
        return this.storeFilters.color
      },
      set: function (val) {
        this.storeFilters = { ...this.storeFilters, color: val }
        this.$emit('update:isMobile', this.type === 'mobile')
      }
    },
    productTypesFilterModel: {
      get: function () {
        return this.storeFilters.productTypes
      },
      set: function (val) {
        this.storeFilters = { ...this.storeFilters, productTypes: val }
        this.$emit('update:isMobile', this.type === 'mobile')
      }
    },
    categoriesFilterModel: {
      get: function () {
        return this.storeFilters.categories
      },
      set: function (val) {
        this.storeFilters = { ...this.storeFilters, categories: val }
        this.$emit('update:isMobile', this.type === 'mobile')
      }
    },
    priceFilterModel: {
      get: function () {
        return this.storeFilters?.price || [0, this.rangePrice.max]
      },
      set: function (val) {
        this.storeFilters = { ...this.storeFilters, price: val }
        this.$emit('update:isMobile', this.type === 'mobile')
      }
    }
  },
  watch: {
    selectAllProductVersion(value) {
      if (value) {
        this.productVersionsSelectModel = this.filters.product_versions.map(
          (item) => item.id
        )
      } else {
        this.productVersionsSelectModel = []
      }
    },
    selectAllCategories(value) {
      if (value) {
        this.productTypesFilterModel = this.filters.categories.map(
          (item) => item.id
        )
      } else {
        this.productTypesFilterModel = []
      }
    },
    selectAllProductTypes(value) {
      if (value) {
        this.categoriesFilterModel = this.filters.product_types.map(
          (item) => item.id
        )
      } else {
        this.categoriesFilterModel = []
      }
    }
  }
}
</script>
<style src="@vueform/slider/themes/default.css"></style>

<style lang="postcss" scoped>
.accordion-item {
  @apply !border-[#C4C4C4];
}
.filter-cod {
  background: #ffffff00;
  box-shadow: 0 0 0;
}
.form-check-input[type='checkbox'] {
  box-shadow: 0 0 0;
  width: 24px;
  height: 24px;
  border: 1px solid #c4c4c4;
  background: #f1f1f1;
}
.form-check-input[type='checkbox']:checked {
  /* Amarillo */

  background: #faa306;
  /* Amarillo */

  border: 1px solid #faa306;
  border-radius: 4px;
  width: 24px;
  height: 24px;
}

.color-picker {
  box-shadow: 0 0 0;
  width: 24px;
  height: 24px;
  border: none;
  display: inline-block;
  transition: 0.3s all;
}
.color-picker:hover {
  -webkit-box-shadow: inset 0px 0px 0px 4px white;
  -moz-box-shadow: inset 0px 0px 0px 4px white;
  box-shadow: inset 0px 0px 0px 4px white;
}
.color-picker-active {
  -webkit-box-shadow: inset 0px 0px 0px 4px white;
  -moz-box-shadow: inset 0px 0px 0px 4px white;
  box-shadow: inset 0px 0px 0px 4px white;
}
.Aqua {
  background: aqua;
}
.White {
  background: #ffffffd6;
}
.Yellow {
  background: #faa306;
}

.Orange {
  background: #e85c04;
}
.Red {
  background: #ce0100;
}
.Beige {
  background: beige;
}
.Gray {
  background: gray;
}
.Pink {
  background: pink;
}
.Green {
  background: green;
}
.Blue {
  background: navy;
}
.Black {
  background: black;
}
.Purple {
  background: purple;
}

.slider-custom {
  --slider-connect-bg: #ffde89;
  --slider-tooltip-bg: #faa306;
  --slider-handle-ring-color: #ef444430;
}
</style>
